var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00016 2.66732C5.05464 2.66732 2.66683 5.05513 2.66683 8.00065C2.66683 10.9462 5.05464 13.334 8.00016 13.334C10.9457 13.334 13.3335 10.9462 13.3335 8.00065C13.3335 5.05513 10.9457 2.66732 8.00016 2.66732ZM1.3335 8.00065C1.3335 4.31875 4.31826 1.33398 8.00016 1.33398C11.6821 1.33398 14.6668 4.31875 14.6668 8.00065C14.6668 11.6825 11.6821 14.6673 8.00016 14.6673C4.31826 14.6673 1.3335 11.6825 1.3335 8.00065ZM5.52876 5.52925C5.78911 5.2689 6.21122 5.2689 6.47157 5.52925L8.00016 7.05784L9.52876 5.52925C9.78911 5.2689 10.2112 5.2689 10.4716 5.52925C10.7319 5.7896 10.7319 6.21171 10.4716 6.47205L8.94297 8.00065L10.4716 9.52925C10.7319 9.7896 10.7319 10.2117 10.4716 10.4721C10.2112 10.7324 9.78911 10.7324 9.52876 10.4721L8.00016 8.94346L6.47157 10.4721C6.21122 10.7324 5.78911 10.7324 5.52876 10.4721C5.26841 10.2117 5.26841 9.7896 5.52876 9.52925L7.05735 8.00065L5.52876 6.47205C5.26841 6.21171 5.26841 5.7896 5.52876 5.52925Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/close-circle.4a32c81c28e069379923ddae3b60e042.svg";
export { ForwardRef as ReactComponent };